// extracted by mini-css-extract-plugin
export var formButtonsContainer = "styles-module__formButtonsContainer___AoYDN";
export var formButton = "styles-module__formButton___WN5Zo";